import Swiper from 'swiper';
import { Autoplay, Pagination, A11y, Keyboard } from 'swiper/modules';

export default function initImageContent() {
  const blocks = document.querySelectorAll('.aviatrix-block--image-content');

  blocks.forEach(block => {
    const column = block.querySelector('.image-content__image');
    if (!column) return;

    const images = Array.from(column.querySelectorAll(':scope > .wp-block-image'));
    if (images.length < 2) return;

    const slider = document.createElement('div');
    slider.className = 'image-content__slider';
    slider.setAttribute('role', 'group');
    slider.setAttribute('aria-roledescription', 'carousel');
    slider.setAttribute('aria-label', 'Image slideshow');

    const track = document.createElement('div');
    track.className = 'image-content__slider-track';

    images.forEach(image => {
      const slide = document.createElement('div');
      slide.className = 'image-content__slide';
      slide.appendChild(image);
      track.appendChild(slide);
    });

    slider.appendChild(track);
    column.appendChild(slider);

    const template = block.querySelector('.image-content__controls-template');
    let pagination = null;
    let toggle = null;

    if (template && template.content) {
      const controls = template.content.firstElementChild.cloneNode(true);
      slider.appendChild(controls);
      pagination = controls.querySelector('.image-content__pagination');
      toggle = controls.querySelector('.image-content__playpause');
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const swiper = new Swiper(slider, {
      modules: [Autoplay, Pagination, A11y, Keyboard],
      wrapperClass: 'image-content__slider-track',
      slideClass: 'image-content__slide',
      slidesPerView: 1,
      loop: true,
      watchSlidesProgress: true,
      keyboard: { enabled: true, onlyInViewport: true },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      a11y: {
        prevSlideMessage: 'Previous image',
        nextSlideMessage: 'Next image',
      },
      pagination: pagination ? {
        el: pagination,
        clickable: true,
        bulletClass: 'image-content__bullet',
        bulletActiveClass: 'image-content__bullet--active',
      } : false,
    });

    let paused = reduceMotion;
    if (paused) {
      swiper.autoplay.stop();
    }

    slider.addEventListener('focusin', () => {
      if (!paused) swiper.autoplay.pause();
    });

    slider.addEventListener('focusout', event => {
      if (!paused && !slider.contains(event.relatedTarget)) swiper.autoplay.resume();
    });

    if (!toggle) return;

    const setPaused = value => {
      paused = value;
      toggle.classList.toggle('is-paused', value);
      toggle.setAttribute(
        'aria-label',
        value ? toggle.dataset.labelPlay : toggle.dataset.labelPause
      );
    };

    setPaused(paused);

    toggle.addEventListener('click', () => {
      const next = !paused;
      if (next) {
        swiper.autoplay.stop();
      } else {
        swiper.autoplay.start();
      }
      setPaused(next);
    });
  });
}
